import { REQUIRED } from "../../constants/validations";

const validate = (values) => {
  let errors = {};

  if (!values.first_name) {
    errors.first_name = REQUIRED;
  }

  if (!values.last_name) {
    errors.last_name = REQUIRED;
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/Screens/BorrowerInfo2/validations.js